/* eslint-disable react/prop-types */

import { useComparisonPlansV21 } from '../../../utils/useComparisonPlansV21';
import ComparisonTable, { COMPARISON_TABLE_FEATURES_TYPES } from '../../ComparisonTable';

const ComparisonTableV21 = ({
  planBlocks,
  selectedPlanId,
  onPlanSelect,
  disableAllButtons,
  hideAllButtons,
  isUpdatingCurrency,
  showDecimals,
  hideSMSinfo,
  isAuCustomer = false,
  isGbCustomer = false,
  smsStartingPrice,
}) => {
  const { plans, scrollIntoViewButtonLabel } = useComparisonPlansV21({
    planBlocks,
    selectedPlanId,
    onPlanSelect,
    disableAllButtons,
    hideAllButtons,
    isUpdatingCurrency,
    showDecimals,
  });

  if (plans.length === 0) return null;

  return (
    <ComparisonTable
      plans={plans}
      featuresType={COMPARISON_TABLE_FEATURES_TYPES.V21}
      withScrollIntoViewButton
      scrollIntoViewButtonLabel={scrollIntoViewButtonLabel}
      hideSMSinfo={hideSMSinfo}
      isAuCustomer={isAuCustomer}
      isGbCustomer={isGbCustomer}
      smsStartingPrice={smsStartingPrice}
    />
  );
};

export default ComparisonTableV21;
